import React from 'react';
import { HowItWorksConnections } from '../components/HowItWorksConnections';
import { LivesInSlack } from '../components/LivesInSlack';
import { ComputerUse } from '../components/ComputerUse';
import { CapabilityGrid } from '../components/CapabilityGrid';
import { NarrativeSection } from '../components/NarrativeSection';
import { ToolComparison } from '../components/ToolComparison';
import { WallOfLove } from '../components/WallOfLove';
import { GettingStartedSteps } from '../components/GettingStartedSteps';
import { PricingSection } from '../components/PricingSection';
import { ClosingCTA } from '../components/ClosingCTA';
import { AudienceSwitch } from '../components/AudienceSwitch';
import { NovaSection } from '../components/nova/NovaSection';
import { SlackIntegrationGraph } from '../components/SlackIntegrationGraph';
// New Giga home screen. The hero is the "Ask Giga anything, get it done."
// chat-box composer (HowItWorksConnections in hero mode), presented as a
// proper website hero. The Slack "@mention Giga" experience remains its own
// "Works where you work" section further down the page.
// The "AI Co-Pilot for Teams" homepage still lives at /future.
export function Home() {
  return <>
      <HowItWorksConnections mode="hero" data-id="element-4239" />
      {/* <NovaSection /> Hidden per user request */}
      <SlackIntegrationGraph data-id="element-4240" />
      {/* "How it works" / Plug-and-play moved above the Giga for You / Team
              audience switch per the intended narrative flow. */}
      <GettingStartedSteps data-id="element-4241" />
      <AudienceSwitch data-id="element-4242" />
      {/* <LivesInSlack /> Hidden from home for now — kept for reuse on another page later */}
      <ComputerUse data-id="element-4243" />
      <CapabilityGrid data-id="element-4244" />
      <NarrativeSection data-id="element-4245" />
      <ToolComparison data-id="element-4246" />
      <WallOfLove data-id="element-4247" />
      <PricingSection data-id="element-4248" />
      <ClosingCTA data-id="element-4249" />
    </>;
}